/**
 * Collapses document/software center sub-routes to their root entry slug.
 * Shared by the page API (breadcrumb trail) and useContentfulPage (fetch slug).
 */
export function collapseContentCenterSlug(
  rawSlug: string,
  documentCenterSlug: string | undefined,
  softwareCenterSlug: string | undefined
): string {
  if (!rawSlug) {
    return rawSlug;
  }

  const normalizedRaw = rawSlug.toLowerCase();

  if (documentCenterSlug) {
    const documentRoot = documentCenterSlug.toLowerCase();
    if (normalizedRaw.startsWith(documentRoot)) {
      return documentRoot;
    }
  }

  if (softwareCenterSlug) {
    const softwareRoot = softwareCenterSlug.toLowerCase();
    if (normalizedRaw.startsWith(softwareRoot)) {
      return softwareRoot;
    }
  }

  return rawSlug;
}
